import React, { useEffect } from "react";

export function LightboxModal({ items, index, onClose, onPrev, onNext, arrowStyle = "solid" }) {
  const item = items?.[index];

  useEffect(() => {
    if (index == null) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "ArrowLeft") onPrev?.();
      if (e.key === "ArrowRight") onNext?.();
    };

    document.addEventListener("keydown", onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [index, onClose, onPrev, onNext]);

  if (!item) return null;

  const arrowBase =
    "absolute top-1/2 -translate-y-1/2 z-10 w-16 h-16 md:w-20 md:h-20 text-gray-300 text-5xl md:text-6xl leading-none hover:text-gray-100 focus:outline-none focus-visible:ring-0";

  const arrowBg =
    arrowStyle === "transparent" ? "bg-transparent hover:bg-transparent" : "bg-black/60 hover:bg-black/75";

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Image preview"
      className="fixed inset-0 z-[9999] bg-black/95"
      onMouseDown={(e) => {
        // Click outside to close
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      {/* Controls */}
      <div className="absolute top-4 right-4 flex items-center gap-3">
        <button
          type="button"
          className="px-4 py-2 bg-black border border-black text-gray-100 hover:bg-black/80 focus:outline-none focus-visible:ring-0"
          style={{ outline: "none" }}
          onClick={onClose}
        >
          Close
        </button>
      </div>

      <button
        type="button"
        aria-label="Previous image"
        className={`${arrowBase} left-4 ${arrowBg}`}
        style={{ outline: "none" }}
        onClick={onPrev}
      >
        ‹
      </button>
      <button
        type="button"
        aria-label="Next image"
        className={`${arrowBase} right-4 ${arrowBg}`}
        style={{ outline: "none" }}
        onClick={onNext}
      >
        ›
      </button>

      {/* Image */}
      <div className="h-full w-full flex items-center justify-center px-6 py-10">
        <img
          src={item.src}
          alt={item.alt ?? item.name}
          className="max-h-[92vh] max-w-[92vw] w-auto h-auto object-contain block bg-black"
          draggable={false}
        />
      </div>
    </div>
  );
}

